import { createRoot } from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import App from "./App.tsx";
import "./i18n";
import "./index.css";
import { startVersionCheck } from "./utils/versionCheck";

// Remove static robots/googlebot meta tags so react-helmet-async is the single source of truth
const removeStaticRobotsMeta = () => {
  document.querySelectorAll('meta[name="robots"], meta[name="googlebot"]').forEach((el) => el.remove());
};

removeStaticRobotsMeta();

createRoot(document.getElementById("root")!).render(
  <HelmetProvider>
    <App />
  </HelmetProvider>
);

// Version polling for fresh deploys
startVersionCheck();
